// extracted by mini-css-extract-plugin
export default {"container":"container__K5nq1","menuRoot":"menuRoot__sQPj1","menuIcon":"menuIcon__YNfOw","title":"title__S7cc9"};